/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownRightIcon20Regular = forwardRef('ArrowDCornerDownRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.75 10.5c0 .966.784 1.75 1.75 1.75h10.528l-4.146-3.957a.75.75 0 1 1 1.036-1.086l4.363 4.166a2.25 2.25 0 0 1 0 3.255l-4.363 4.165a.75.75 0 0 1-1.036-1.085l4.146-3.958H5.5a3.25 3.25 0 0 1-3.25-3.25V2a.75.75 0 0 1 1.5 0v8.5Z" })));
});
